// KEATS variant picker redesign v6 — May 27 2026 (color-matched to Recharge teal #0F866A)
// v3: simplified per-card (strikethrough + new price + save 15%)
// v4: moved Save 15% out of cards into single banner above
// v5: cards REACT to Subscribe vs One-time radio state in Recharge widget shadow DOM
//     - Subscribe selected → banner visible, cards show strikethrough + sub price
//     - One-time selected → banner hidden, cards show one-time price only
(function () {
  'use strict';

  var BRAND = '#0F866A';
  var BRAND_LIGHT = '#e8f4ef';
  var REBUILT_FLAG = 'data-keats-redesigned-v6';

  function parseLabel(text) {
    var t = text || '';
    var titleMatch = t.match(/(\d+\s*DAY\s*MEAL)/i);
    var priceMatch = t.match(/\$(\d+(?:\.\d+)?)/);
    return {
      title: titleMatch ? titleMatch[1].toUpperCase() : t.split('\n')[0].trim(),
      oneTime: priceMatch ? parseFloat(priceMatch[1]) : null
    };
  }

  function getPurchaseMode() {
    var w = document.querySelector('recharge-subscription-widget');
    if (!w || !w.shadowRoot) return 'subscription'; // default to subscription
    var checked = w.shadowRoot.querySelector('input[name="purchaseOption"]:checked');
    return checked ? checked.value : 'subscription';
  }

  function buildInnerSub(title, oneTime) {
    var subStr = '$' + (oneTime * 0.85).toFixed(2);
    var oneTimeStr = '$' + oneTime.toFixed(2);
    return (
      '<div style="font-size:11px;font-weight:700;color:#1a1a1a;letter-spacing:1px;text-align:center;text-transform:uppercase;line-height:1.1;">'
      + title + '</div>'
      + '<div style="font-size:12px;color:#888;text-decoration:line-through;line-height:1.1;margin-top:8px;">'
      + oneTimeStr + '</div>'
      + '<div style="font-size:18px;font-weight:800;color:' + BRAND + ';line-height:1.1;margin-top:2px;">'
      + subStr + '</div>'
    );
  }

  function buildInnerOneTime(title, oneTime) {
    var oneTimeStr = '$' + oneTime.toFixed(2);
    return (
      '<div style="font-size:11px;font-weight:700;color:#1a1a1a;letter-spacing:1px;text-align:center;text-transform:uppercase;line-height:1.1;">'
      + title + '</div>'
      + '<div style="font-size:18px;font-weight:800;color:#1a1a1a;line-height:1.1;margin-top:12px;">'
      + oneTimeStr + '</div>'
    );
  }

  function buildBanner() {
    var banner = document.createElement('div');
    banner.id = 'keats-picker-save-banner';
    banner.style.cssText = [
      'display: block',
      'background: ' + BRAND,
      'color: #ffffff',
      'font-size: 11px',
      'font-weight: 700',
      'letter-spacing: 0.8px',
      'text-transform: uppercase',
      'text-align: center',
      'padding: 6px 10px',
      'border-radius: 4px',
      'margin: 14px 0 8px',
      'box-sizing: border-box'
    ].join('; ');
    banner.textContent = 'Save 15% with subscription on every plan';
    return banner;
  }

  function renderCards() {
    var picker = document.querySelector('.keats-variant-picker');
    if (!picker) return;
    var labels = picker.querySelectorAll('label[data-keats-variant-id]');
    var mode = getPurchaseMode();
    var isSub = mode === 'subscription';

    // Show/hide banner per mode
    var banner = document.getElementById('keats-picker-save-banner');
    if (banner) banner.style.display = isSub ? 'block' : 'none';

    labels.forEach(function (label) {
      var cached = label.getAttribute('data-keats-cached-title');
      var oneTime = parseFloat(label.getAttribute('data-keats-cached-onetime'));
      if (!cached || isNaN(oneTime)) return;

      var radio = label.querySelector('input[type=radio]');
      var checked = radio && radio.checked;
      label.style.borderColor = checked ? BRAND : '#e5e5e5';
      label.style.background = checked ? BRAND_LIGHT : '#ffffff';

      // Re-render the inner content div (NOT the radio input)
      var contentDiv = label.querySelector('[data-keats-content]');
      if (!contentDiv) {
        contentDiv = document.createElement('div');
        contentDiv.setAttribute('data-keats-content', '1');
        label.appendChild(contentDiv);
      }
      contentDiv.innerHTML = isSub
        ? buildInnerSub(cached, oneTime)
        : buildInnerOneTime(cached, oneTime);
    });
  }

  function setup() {
    var picker = document.querySelector('.keats-variant-picker');
    if (!picker || picker.hasAttribute(REBUILT_FLAG)) return false;
    var labels = picker.querySelectorAll('label[data-keats-variant-id]');
    if (labels.length === 0) return false;

    // Parse + cache per label
    var anyMissing = false;
    labels.forEach(function (label) {
      var parsed = parseLabel(label.innerText);
      if (!parsed.oneTime) { anyMissing = true; return; }
      label.setAttribute('data-keats-cached-title', parsed.title);
      label.setAttribute('data-keats-cached-onetime', String(parsed.oneTime));
    });
    if (anyMissing) return false;

    // Lay out
    var radiogroup = picker.querySelector('[role=radiogroup]') || labels[0].parentElement;
    if (!document.getElementById('keats-picker-save-banner')) {
      var banner = buildBanner();
      radiogroup.parentNode.insertBefore(banner, radiogroup);
    }
    radiogroup.style.cssText = [
      'display: grid',
      'grid-template-columns: repeat(auto-fit, minmax(85px, 1fr))',
      'gap: 8px',
      'margin: 0 0 6px',
      'padding: 0',
      'width: 100%',
      'box-sizing: border-box'
    ].join('; ');

    labels.forEach(function (label) {
      var radio = label.querySelector('input[type=radio]');
      label.style.cssText = [
        'position: relative',
        'cursor: pointer',
        'border: 2px solid #e5e5e5',
        'border-radius: 10px',
        'padding: 10px 6px',
        'background: #ffffff',
        'transition: border-color 0.15s, background 0.15s',
        'box-sizing: border-box',
        'text-align: center',
        'min-width: 0'
      ].join('; ');
      // Clear inner content (keep radio)
      var existingRadio = label.querySelector('input[type=radio]');
      label.innerHTML = '';
      if (existingRadio) {
        existingRadio.style.cssText = 'position:absolute;opacity:0;pointer-events:none;';
        label.appendChild(existingRadio);
      }
    });

    renderCards();

    // Listen for variant changes
    picker.addEventListener('change', renderCards, true);
    picker.addEventListener('click', function () { setTimeout(renderCards, 50); }, true);

    // Listen for Subscribe/One-time changes from Recharge widget shadow DOM
    // Strategy: composed events bubble through shadow boundary if composed:true.
    // Recharge's events may not all compose, so also poll.
    document.addEventListener('change', function (e) {
      var t = e.composedPath ? e.composedPath()[0] : e.target;
      if (t && t.name === 'purchaseOption') renderCards();
    }, true);

    // Poll fallback every 500ms — cheap, robust against Recharge not dispatching composed events
    var lastMode = getPurchaseMode();
    setInterval(function () {
      var m = getPurchaseMode();
      if (m !== lastMode) {
        lastMode = m;
        renderCards();
      }
    }, 500);

    picker.setAttribute(REBUILT_FLAG, '1');
    return true;
  }

  var attempts = 0;
  var pollId = setInterval(function () {
    attempts++;
    if (setup() || attempts > 60) clearInterval(pollId);
  }, 200);
})();
